import { IsAdmin } from "../Helpers/Utilities";
import WebServiceWrapper from "./WebServiceWrapper";

export const HospitalizationService = {
    LoadData,
    SaveData
};
function LoadData(pid, loggedInUserId) {
    return WebServiceWrapper.Get(`/hospitalization/GetHospitalizationData?patientId=${pid}&&loggedInUserId=${loggedInUserId}&isAdmin=${IsAdmin()}`);
}
function SaveData(payload) {
    return WebServiceWrapper.Post("/hospitalization/SaveHospitalizationData", payload);
}
